/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { Fragment } from 'react';
import { DialogContent, Tooltip } from '@mui/material';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import './style.css';
import CloseIcon from '@mui/icons-material/Close';

const DocumentViewer = (props) =>
{
	const extension = props?.file?.key?.split('.').pop();

	return (
		<Fragment>
			<div className='flexCol fxdFilePlayerCntr alignCntr justifyCntr scrollY'>
				<button className='flexInline slideBtns slideCloseBtn alignCntr justifyCntr' onClick={props?.closeCallBack}>
					<Tooltip title='Close' >
						<CloseIcon />
					</Tooltip>
				</button>
				<div className='resPColRow fullHeight'>
					<div className='previewImage scrollY '>
						<div className='flexMinHeightCol alignCntr fullHeight'>
							<div className='  flexRow previewSlideItem  justifyCntr'>
								<div className='flexRow mrgnTMD  justifyCntr edmImgCntr'>

									<DialogContent className='dialogContent508'>

										<DocViewer
											className='docViewCntr brdrRadiusSM'
											pluginRenderers={DocViewerRenderers}
											documents={[ { uri: props?.url, fileType: extension } ]}
										/>

									</DialogContent>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</Fragment>
	);
};

export default React.memo(DocumentViewer);